import {
  ErrorResponse,
  isErrorResponse,
  isSubscriptionResponse,
  subscribeToNewsletter,
  SubscriptionResponse,
} from '@firstlookmedia/newsletter';

import { dispatchEventToParent, isMessageFromParent } from './messaging';

const subscribeEventName = 'newsletter:subscribe';

const getSubscribeResponse = async (
  event: MessageEvent,
): Promise<ErrorResponse | SubscriptionResponse | null> => {
  if (!(await isMessageFromParent(event))) {
    return null;
  }

  if (typeof event.data !== 'object' || typeof event.data.piano !== 'object') {
    return null;
  }

  const response = event.data.piano;
  if (!isErrorResponse(response) && !isSubscriptionResponse(response)) {
    return null;
  }

  return response;
};

export const subscribe: typeof subscribeToNewsletter = (
  request,
  { serviceOrigin } = {},
) =>
  new Promise((resolve, reject) => {
    dispatchEventToParent(subscribeEventName, { ...request, serviceOrigin });

    const handleMessage = async (event: MessageEvent) => {
      const response = await getSubscribeResponse(event);
      if (!response) {
        return;
      }

      window.removeEventListener('message', handleMessage);

      if (response.status === 'error') {
        reject(new Error(response.message));
      } else {
        resolve(response);
      }
    };

    window.addEventListener('message', handleMessage, false);
  });
